import { Badge } from '@/components/ui/badge'
import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip'

/**
 * Health column cell. Colour-codes a real 0–100 score when one is available;
 * otherwise shows a neutral "—" with a tooltip explaining the gap. It NEVER
 * fabricates a score — health telemetry is gated on TMA-601, so today this
 * always renders the "—" path until the product starts emitting `health`.
 */
export function HealthCell({ health }: { health?: number | null }) {
  if (typeof health !== 'number' || Number.isNaN(health)) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            tabIndex={0}
            className="cursor-help font-mono text-cmd-outline focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary"
            aria-label="Health score unavailable — needs telemetry feed (TMA-601)"
          >
            —
          </span>
        </TooltipTrigger>
        <TooltipContent>Needs telemetry feed (TMA-601)</TooltipContent>
      </Tooltip>
    )
  }

  const score = Math.round(health)
  const variant = score >= 80 ? 'success' : score >= 50 ? 'warning' : 'destructive'
  return (
    <Badge variant={variant} className="tabular-nums">
      {score}
    </Badge>
  )
}
